module.exports = __webpack_public_path__ + "img/dataMiddleground-charafunction3.631a542b.png";